exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".footer[data-v-4a283a41]{opacity:.8;font-size:.9em}.footer a[data-v-4a283a41]{color:var(--bs-body-color-rgb)}.infos[data-v-4a283a41]{margin:2em 0 0 0;text-align:center}.link-icons svg[data-v-4a283a41]{font-size:2em;margin:.25em 0}", ""]);

